/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 10.04.13
 * Time: 14:27
 */

import { debug } from "../logging/debug";
import { info } from "../logging/info";
import { IOfferDescription } from "./offerDescriptions/IOfferDescription";
import { OfferDescriptionAutoAccept } from "./offerDescriptions/OfferDescriptionAutoAccept";
import { OfferDescriptionRewards } from "./offerDescriptions/OfferDescriptionRewards";
import { OfferDescriptionVisuals } from "./offerDescriptions/OfferDescriptionVisuals";
import { IOfferDescriptionRewardParameter } from "./offerDescriptions/rewards/IOfferDescriptionRewardParameter";
import { IOfferDescriptionVisualParameter } from "./offerDescriptions/visualizations/IOfferDescriptionVisualParameter";
import { IOfferQuestCondition } from "./offerQuestConditions/IOfferQuestCondition";
import { OfferQuestConditionContainer } from "./offerQuestConditions/OfferQuestConditionContainer";
import { PrivateOfferStateEnum } from "./PrivateOfferStateEnum";
import { Constants_Offer } from "./Constants_Offer";

export class BasicPrivateOfferVO {
    private _id: number;
    private _endTimestamp: number;
    private _hasInfiniteTime: boolean;
    private _questConditions: OfferQuestConditionContainer;
    private _description: Map<any, any>;
    private _offerState: PrivateOfferStateEnum;
    private _hasRequestedNewTime: boolean = false;

    constructor() {

    }

    public dispose(): void {
        this._id = -1;

        // TODO: HTML5 - removed an awkward, useless loop, check if the logic works
        this._questConditions.dispose();

        this._questConditions = null;
        this._description = null;
        this._offerState = null;
    }

    /**
     * initialize the offerVO with params from server
     */
    public loadFromParamObject(id: number, offerState: PrivateOfferStateEnum, endTimestamp: number = -1, hasInfiniteTime: boolean = true, description: Map<any, any> = null, questConditionContainer: OfferQuestConditionContainer = null): void {
        if (id > 0) {
            this._id = id;
        }

        if (offerState) {
            this._offerState = offerState;
        }

        this._endTimestamp = endTimestamp;
        this._hasInfiniteTime = hasInfiniteTime;

        if (description) {
            this._description = description;
        }
        else {
            this._description = new Map<any, any>();
        }

        this._questConditions = questConditionContainer;
    }

    /**
     * Return remaining seconds for current state
     * @return
     */
    public get remainingSeconds(): number {
        return Math.max(0, (this._endTimestamp - Date.now()) * 0.001);
    }

    /**
     * Return get remaining Time in milliseconds
     * @return
     */
    public getRemainingTimeInMS(): number {
        return Math.max(0, (this._endTimestamp - Date.now()));
    }

    /**
     * Return seconds after endTimestamp
     * @return
     */
    public get secondsOverTime(): number {
        return (Date.now() - this._endTimestamp) * 0.001;
    }

    /**
     * Offer id
     */
    public get id(): number {
        return this._id;
    }

    /**
     * Flag if offer has a remaining time for current state or is infinite
     */
    public get hasInfiniteTime(): boolean {
        return this._hasInfiniteTime;
    }

    /**
     * Current offer state
     */
    public get offerState(): PrivateOfferStateEnum {
        return this._offerState;
    }

    /**
     * change the current state of this offer
     * @param newState
     */
    public changeState(newState: PrivateOfferStateEnum): void {
        this._offerState = newState;
    }

    /**
     * update the actual remaining seconds for the current state
     * @param newDuration in seconds (-1: infinite)
     */
    public updateDuration(newDuration: number): void {
        if (newDuration != -1)      // if new duration is -1, set infinite time flag
        {
            this._endTimestamp = Date.now() + newDuration * 1000;
            this._hasInfiniteTime = false;
        }
        else {
            this._endTimestamp = -1;
            this._hasInfiniteTime = true;
        }

        this._hasRequestedNewTime = false;
    }

    /**
     * Tries to get the offer description by name
     * @param name
     * @return IOfferDescription if found, otherwise null;
     */
    public getDescriptionByName(name: string): IOfferDescription {
        return this._description.get(name);
    }

    /**
     * Check if the offer has the description with this name
     * @param name
     * @return
     */
    public hasDescription(name: string): boolean {
        return this._description.get(name) !== undefined;
    }

    /**
     * Tries to get a visual parameter by name
     * @param name
     * @return IOfferDescriptionVisualParameter Object if found, otherwise null
     */
    public getVisualComponentByName(name: string): IOfferDescriptionVisualParameter {
        let visuals: OfferDescriptionVisuals = (<OfferDescriptionVisuals>this._description.get(Constants_Offer.VISUAL_COMPONENT_CONTAINER));
        if (visuals && visuals.visuals[name]) {
            return visuals.visuals[name];
        }
        return null;
    }

    /**
     * Tries to get a reward parameter by name
     * @param name
     * @return IOfferDescriptionRewardParameter object if found, otherwise null
     */
    public getRewardComponentByName(name: string): IOfferDescriptionRewardParameter {
        let rewards: OfferDescriptionRewards = (<OfferDescriptionRewards>this._description.get(Constants_Offer.REWARD_COMPONENT_CONTAINER));
        if (rewards && rewards.rewards[name]) {
            return rewards.rewards[name];
        }
        return null;
    }

    // those 2 methodes must be created in the sub classes
    /*
     * Returns a merged RewardVO from all reward description parameters in this offer
     * @return RewardVO with all reward from this offer
     */
    /*
     public function getTotalRewardFromOfferVO():RewardVO
     {
     let rewardVO:RewardVO = new RewardVO();
     for each (let reward:IOfferDescriptionRewardParameter in (_description[Constants_Offer.REWARD_COMPONENT_CONTAINER] as OfferDescriptionRewards).rewards)
     {
     rewardVO.addRewardVO(reward.getRewardsVO());
     }
     return rewardVO;
     }
     */
    /*
     * Return all costs of this offer merged in one GoodsVO
     * @return GoodsVO with all costs to accept this offer
     */

    /*
     public function getCostsForOfferAcception():GoodsVO
     {
     //  0 	   1      2    3   4   5       6        7
     // wood, stone, food, c1, c2, coal, oliveoil, glass

     let costsObject:Array = new Array(8);
     if(_description[Constants_Offer.OFFER_COST_C1] !== undefined)
     costsObject[3] = (_description[Constants_Offer.OFFER_COST_C1] as OfferDescriptionCostC1).costC1;

     if(_description[Constants_Offer.OFFER_COST_C2] !== undefined)
     costsObject[4] = (_description[Constants_Offer.OFFER_COST_C2] as OfferDescriptionCostC2).costC2

     // Empire Goods
     if( _description[Constants_Offer.OFFER_COST_EMPIRE_RESOURCES] !== undefined)
     {
     let odcr:OfferDescriptionCostResources = _description[Constants_Offer.OFFER_COST_EMPIRE_RESOURCES] as OfferDescriptionCostResources;
     costsObject[0] = odcr.wood;
     costsObject[1] = odcr.stone;
     costsObject[2] = odcr.food;
     costsObject[5] = odcr.coal;
     costsObject[6] = odcr.oil;
     costsObject[7] = odcr.glass;
     }

     let goodsVO:GoodsVO = new GoodsVO();
     goodsVO.loadFromParamArray(costsObject);
     return goodsVO;
     }
     */

    /**
     * Returns the dictionary with all quest conditions
     * @return
     */
    public getQuestConditions(): Map<any, any> {
        return this._questConditions.questConditions;
    }

    /**
     * Returns true if all sub-conditions passed
     * @return
     */
    public allQuestConditionsPassed(): boolean {
        return this._questConditions.conditionPassed;
    }

    /**
     * Tries to get a quest condition by name
     * @param name condition name
     * @return IOfferQuestCondition (null if no condition with this name found)
     */
    public getQuestConditionByName(name: string): IOfferQuestCondition {
        return this._questConditions.questConditions[name];
    }

    /**
     * Checks if autoAccept is set and return the value
     * @return if set returns autoAccept, otherwise returns false
     */
    public hasAutoAccept(): boolean {
        if (this._description.get(Constants_Offer.OFFER_AUTO_ACCEPT) !== undefined) {
            return ((<OfferDescriptionAutoAccept>this.getDescriptionByName(Constants_Offer.OFFER_AUTO_ACCEPT))).autoAccept;
        }
        else {
            return false;
        }
    }

    /***************
     * DEBUG STUFF *
     ***************/
    public tracefOffer(): void {
        debug("---- PrivateOffer ----");
        debug("OfferID: " + this._id);
        debug("EndtimeStamp: " + this._endTimestamp + " --> remaining: " + ((this._endTimestamp - Date.now()) * 0.001));
        debug("OfferState: " + this._offerState.toString());
        debug("QuestConditions --->" + this._questConditions.toString());
        debug("OfferDescription --->");

        for (let descriptionKey of Array.from(this._description.keys())) {
            let value: IOfferDescription = this._description.get(descriptionKey);
            debug("   " + descriptionKey + " --> " + value);
        }

        debug("---- PrivateOfferEnd ----")
    }

    public toString(): string {
        let text: string = "---- PrivateOffer ----";
        text += "\nOfferID: " + this._id;
        text += "\nEndtimeStamp: " + this._endTimestamp + " --> remaining: " + ((this._endTimestamp - Date.now()) * 0.001);
        text += "\nOfferState: " + this._offerState.toString();
        if (this._questConditions) {
            text += "\nQuestConditions --->" + this._questConditions.toString();
        }
        info("OfferDescription --->");

        for (let descriptionKey of Array.from(this._description.keys())) {
            let value: IOfferDescription = this._description.get(descriptionKey);
            text += "\n   " + descriptionKey + " --> " + value;
        }

        text += "---- PrivateOfferEnd ----";
        return text;
    }

    public get hasRequestedNewTime(): boolean {
        return this._hasRequestedNewTime;
    }

    public set hasRequestedNewTime(value: boolean) {
        this._hasRequestedNewTime = value;
    }
}
